import { positionOptions } from '@/constants/option';

export const convertInfoValue = (value: string) => {
	switch (value) {
		case '공지사항':
			return 'notice';
		case '소식지':
			return 'newsletter';
		case '연구동향':
			return 'trend';
		case '갤러리':
			return 'gallery';

		default:
			return 'notice';
	}
};

export const convertPaymentValue = (value: string) => {
	switch (value) {
		case '정회원':
			return '80,000';
		case '학생회원':
			return '20,000';
		case '특별회원':
			return '0';
		case '명예회원':
			return '0';
		default:
			return '0';
	}
};

export const convertPaymentRegisterValue = (value: string) => {
	switch (value) {
		case '정회원':
		case '일반':
			return '70,000';
		case '학생회원':
			return '0';
		case '특별회원':
			return '0';
		case '명예회원':
			return '0';
		default:
			return '0';
	}
};

export const convertPositionValue = (value: string) => {
	const match = positionOptions.find((option) => option.value === value);
	return match ? match.value : '기타(직접입력)';
};
